import ActivityScreen from "@components/Activity/ActivityScreen";

export default ActivityScreen;
